import { Box, Button, Grid, Typography } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import { Loader, Modal, SGSCard, SGSCheckbox, SGSHelpButton, SGSInputSearch, SGSWidgetCard } from '../../components';
import SGSDataGrid from '../../components/SGSDataGrid';
//import { useQueryX } from 'core/hooks';
import { ChartData } from 'chart.js';
import SGSCardTitle from 'components/SGSCard/SGSCardTitle';
import { useAppContext } from 'core/contexts';
import { useCustomStyles } from 'core/mui/customStyles';
import { actualiteService, statsService } from 'core/services';
import { hasFunctionality, hasRole } from 'core/utils/roles';
import moment from 'moment';
import { Bar } from 'react-chartjs-2';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { NavLink, useHistory } from 'react-router-dom';
import YouTube from 'react-youtube';
import Cookies from 'universal-cookie';
import styles from './Master.module.scss';

const useQueryConf = {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 1000 * 60 * 60 * 1,
    cacheTime: 1000 * 60 * 60 * 1,
};

type Props = {};

const Dashboard: React.FC<Props> = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const { user } = useAppContext();
    const commonStyles = useCustomStyles();
    const [filterByRisk, setFilterByrisk] = useState('S');
    const [isOpen, setIsOpenModal] = useState(false);

    useEffect(() => {
        if (!cookies.get('playVideo') || cookies.get('playVideo') === 'true') {
            // Video
            cookies.set('playVideo', true);
            setPlayVideo(true);
            setIsModalOpen(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!user.roles.includes('ROLE_SANTE') && user.roles.includes('ROLE_PREVOYANCE')) setFilterByrisk('P');
        else {
            setFilterByrisk('S');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const { isLoading: affiliesLoading, data: affiliesEmployers } = useQuery(
        [user.login, filterByRisk, 'stats_affilies_employers_home'],
        async () => {
            return hasRole(user, ['ROLE_VALID_ASSURED']) ? await statsService.getAffiliesEmployers(filterByRisk) : Promise.resolve([]);
        },
        useQueryConf,
    );

    const { isLoading: articlesLoading, data: articles } = useQuery(
        [user.login, 'articles_home'],
        async () => {
            return await actualiteService.getLastArticle();
        },
        useQueryConf,
    );
    const { isLoading: cotisationsLoading, data: cotisations } = useQuery(
        [user.login, 'stats_cotisation_home'],
        async () => {
            return hasRole(user, ['ROLE_CONTRIBUTION_SEE']) ? await statsService.getCotisations() : Promise.resolve([]);
        },
        useQueryConf,
    );

    const cotisationsGraphData = useMemo<ChartData<'bar'>>(
        () => ({
            datasets: [
                {
                    borderColor: '#02c4c8',
                    data: cotisations?.map((c) => Number(c.value)) ?? [],
                    backgroundColor: '#2574A9',
                    fill: true,
                    label: t('dashboard.cotisations.card'),
                },
            ],
            labels: cotisations?.map((c) => c.label),
        }),
        [cotisations, t],
    );

    // Modal vidéo
    //* UseForm initialisation
    const methods = useForm({});
    const cookies = new Cookies();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [playVideo, setPlayVideo] = useState(false);

    const opts = {
        height: '390',
        width: '640',
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: 1,
        },
    };

    const handleChangeRisk: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
        setFilterByrisk(e.target.value);
    };

    const setCookieVideo = (value) => {
        setPlayVideo(value);
        const expirationDate = new Date();
        expirationDate.setFullYear(expirationDate.getFullYear() + 2);
        cookies.set('playVideo', value, { expires: expirationDate });
    };

    const options: any = [
        { value: 'S', label: t('dashboard.affilies_employers.sante') },
        { value: 'P', label: t('dashboard.affilies_employers.prevoyance') },
    ];

    const getModalVisibility = () => {
        const isVisible = cookies.get('playVideo') && cookies.get('playVideo') === 'false' ? localStorage.getItem('isModalVisibleTuto') : 'true';
        return isVisible !== null ? JSON.parse(isVisible) : true;
    };

    const setModalVisibility = (isVisible) => {
        localStorage.setItem('isModalVisibleTuto', JSON.stringify(isVisible));
        setIsOpenModal(isVisible);
    };

    useEffect(() => {
        const modalVisible = getModalVisibility();
        if (cookies.get('playVideo') && cookies.get('playVideo') === 'false') setModalVisibility(modalVisible);
    }, []);

    return (
        <>
            <SGSHelpButton />
            <Grid container spacing={4}>
                <Grid item md={12}>
                    {hasRole(user, ['ROLE_VALID_ASSURED']) && (
                        <SGSInputSearch
                            label={t('affiliations.affiliates.searchPlaceholder')}
                            title={t('affiliations.affiliates.search')}
                            onSearch={(searchValue) => {
                                if (!searchValue) {
                                    return;
                                }
                                history.push({ pathname: 'affiliations', search: `search=${searchValue}` });
                            }}
                        />
                    )}
                </Grid>
            </Grid>
            <Grid container spacing={4}>
                <Grid item md={4} xs={12}>
                    <SGSCard
                        onClick={articles ? () => history.push(`/actualites/${articles[0].slug}`) : null}
                        // @ts-ignore
                        color="default"
                        footer={<NavLink to="/actualites">Voir les actualités</NavLink>}
                        title={articles && articles[0] && articles[0].title}
                        widgetTitle={t('dashboard.actualites.card')}
                        widgetColor="midblue"
                        noTitleTranslation
                        className="w-100"
                        image={articles && articles[0] && articles[0].thumbnailImagePath}
                    >
                        {articles && articles[0] && articles[0].createdAt && (
                            <Box>
                                <em>{moment(articles[0].createdAt).format('L')}</em>
                            </Box>
                        )}
                        <Box>{articles && articles[0] && articles[0].incipit}</Box>
                        <Loader loading={articlesLoading} small />
                    </SGSCard>
                </Grid>
                {hasRole(user, ['ROLE_VALID_ASSURED']) && (
                    <Grid item md={4} xs={12}>
                        {/* <SGSWidgetCard className="w-100" color="secondary" footer={<NavLink to="/affiliations">Accédez au détail</NavLink>} title={t('dashboard.affilies_employers.card')}> */}
                        <SGSWidgetCard
                            className="w-100"
                            color="secondary"
                            footer={<NavLink to="/affiliations">Accédez au détail</NavLink>}
                            title={(<SGSCardTitle options={options} value={filterByRisk} setValue={handleChangeRisk} />) as any}
                        >
                            {/*Pour éviter que les données du tableau soient coupés, une scrollbar apparait au dela de 5 éléments*/}
                            {!affiliesLoading && (
                                <div style={{ height: affiliesEmployers?.length > 5 ? '500px' : '100%' }}>
                                    <SGSDataGrid
                                        noHeader
                                        autoHeight={!(affiliesEmployers?.length > 5)}
                                        hideFooter
                                        disableSelectionOnClick
                                        //rowCount={2}
                                        rowMargin={0}
                                        rowHeight={60}
                                        paginationMode="server"
                                        rows={
                                            affiliesEmployers
                                                ?.filter((d) => {
                                                    return d != null;
                                                })
                                                .map((d) => ({
                                                    id: d.employer,
                                                    ...d,
                                                })) ?? []
                                        }
                                        columns={[
                                            {
                                                field: 'employer',
                                                headerName: t('dashboard.affilies_employers.employer'),
                                                flex: 1,
                                                renderCell: (params: any) => <Typography className={styles.tableCell}>{params.value}</Typography>,
                                            },
                                            {
                                                field: 'nb_affilies',
                                                align: 'right',
                                                renderCell: (params: any) => <Typography className={styles.numberCell}>{params.value}</Typography>,
                                            },
                                        ]}
                                    />
                                </div>
                            )}
                            <Loader loading={affiliesLoading} small />
                        </SGSWidgetCard>
                    </Grid>
                )}
                {hasRole(user, ['ROLE_CONTRIBUTION_SEE']) && (
                    <Grid item md={4} xs={12}>
                        <SGSWidgetCard className="w-100" color="primary" title={t('dashboard.cotisations.card')}>
                            {cotisationsGraphData.datasets[0].data.length >= 1 && (
                                <Bar
                                    data={cotisationsGraphData}
                                    options={{
                                        plugins: {
                                            legend: {
                                                position: 'bottom',
                                            },
                                        },
                                        scales: {
                                            y: {
                                                beginAtZero: true,
                                            },
                                        },
                                    }}
                                />
                            )}
                            {!cotisationsLoading && cotisationsGraphData.datasets[0].data.length < 1 && (
                                <Box textAlign="center">
                                    <Typography>{t('dashboard.cotisations.noData')}</Typography>
                                </Box>
                            )}
                            <Loader loading={cotisationsLoading} small />
                        </SGSWidgetCard>
                    </Grid>
                )}
            </Grid>
            <Modal setIsOpenModal={() => setIsModalOpen(false)} title={'Présentation Espace Entreprise'} isOpenModal={isModalOpen}>
                <Box className="text-center">
                    <YouTube videoId="AZpC9fIcI1o" opts={opts} />
                </Box>
                <Box className="text-left mt-2">
                    <FormProvider {...methods}>
                        <SGSCheckbox label={'Ne plus afficher'} value={playVideo} name="video" checked={!playVideo} handleChange={() => setCookieVideo(!playVideo)} />
                    </FormProvider>
                </Box>
            </Modal>
            {hasFunctionality(user, ['PREV']) && (
                <Modal setIsOpenModal={() => setModalVisibility(false)} title={'INFORMATION'} isOpenModal={isOpen} centerTitle={true} centerContent={true}>
                    <Box display="flex" justifyContent="center" style={{ marginBottom: 16, marginTop: '30px' }}>
                        <div style={{ position: 'relative', paddingBottom: '56.25%', width: '100%' }}>
                            <iframe
                                style={{ width: '100%', height: '100%', position: 'absolute', left: 0, top: 0 }}
                                frameBorder="0"
                                allowFullScreen
                                allow="autoplay"
                                src="https://playplay.com/app/embed-video/9ce78b17-8264-4575-9a0a-0bbd83f640cc?autoplay=true"
                            ></iframe>
                        </div>
                    </Box>
                    <Box display="flex" justifyContent="center" style={{ marginBottom: 16, marginTop: '30px' }}>
                        <Button className={commonStyles.btnBlue} style={{ background: '#2574a9', color: '#fff' }} onClick={() => setModalVisibility(false)}>
                            C'est noté
                        </Button>
                    </Box>
                </Modal>
            )}
        </>
    );
};

export default Dashboard;
